import Viola71 from '../../../Media/Cibubur/Glenview/Tipe 10.webp'
import Viola72 from '../../../Media/Cibubur/Glenview/gv10.webp'


const Viola7images =[
Viola71,Viola72,
]

export default Viola7images;